import { setItem } from "../config/config";

export default function aler(message, type = "danger") {
	const obj = { message: message, type: type };
	setItem("message", obj);
	var myEvent = new Event("popUpMessage", { bubbles: true });
	document.dispatchEvent(myEvent);
}
